(function () {
  const normalize = (value) => (value || '').toLowerCase().replace(/\s+/g, ' ').trim();

  const initIndex = () => {
    const root = document.querySelector('[data-h9-ing-index]');
    if (!root) return;
    if (root.dataset.h9Done) return;
    root.dataset.h9Done = 'true';

    const form = root.querySelector('[data-h9-ing-form]');
    const search = root.querySelector('[data-h9-ing-search]');
    const cards = Array.from(root.querySelectorAll('[data-h9-ing-card]'));
    const filterSelect = root.querySelector('[data-h9-ing-filter-select]');
    const empty = root.querySelector('[data-h9-ing-empty]');
    let category = 'all';

    const apply = () => {
      const query = normalize(search && search.value);
      let shown = 0;

      cards.forEach((card) => {
        const hay = normalize(card.getAttribute('data-search'));
        const typeEl = card.querySelector('.h9-ing__card-type');
        const cardCategory = normalize(
          card.getAttribute('data-category') || (typeEl && typeEl.textContent)
        );
        const matchCategory = category === 'all' || cardCategory === category;
        const matchQuery = !query || hay.indexOf(query) !== -1;
        const visible = matchCategory && matchQuery;
        card.hidden = !visible;
        if (visible) shown += 1;
      });

      if (empty) empty.hidden = shown > 0;
      root.classList.toggle('h9-ing--sparse', shown < 4);
    };

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      apply();
    });

    search?.addEventListener('input', apply);

    filterSelect?.addEventListener('change', () => {
      category = normalize(filterSelect.value || 'all');
      apply();
    });

    apply();
  };

  const headingKey = (value) => {
    const text = normalize(value).replace(/[:.]$/, '');
    if (!text) return '';
    if (text === 'role in herbalism') return 'roles';
    if (/at a glance$/.test(text) || text.indexOf('at a glance') !== -1) return 'glance';
    if (text === 'traditional use') return 'use';
    if (text === 'botany') return 'botany';
    if (text === 'origins' || text === 'origins & native' || text.indexOf('origins') === 0) return 'origins';
    if (text.indexOf('humble9') === 0) return 'blends';
    if (text.indexOf('where ') === 0) return 'origin';
    if (text === 'additional information') return 'notes';
    if (text === 'important precautions') return 'precautions';
    if (text === 'disclaimer') return 'disclaimer';
    if (text === 'a closer look' || text.indexOf('a closer look') === 0) return 'closer';
    return '';
  };

  const ROLE_ICONS = [
    {
      match: /(memory|intellect|focus|clarity|mind|cognit)/,
      svg: '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M7 4.5c-1.7 0-3 1.3-3 3 0 .6.2 1.1.4 1.6C3.5 9.6 3 10.5 3 11.5c0 1.5 1 2.7 2.4 3.1.3 1.4 1.5 2.4 3 2.4.6 0 1.1-.2 1.6-.4V4.9c-.6-.3-1.3-.4-2-.4Z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><path d="M13 4.5c1.7 0 3 1.3 3 3 0 .6-.2 1.1-.4 1.6.9.5 1.4 1.4 1.4 2.4 0 1.5-1 2.7-2.4 3.1-.3 1.4-1.5 2.4-3 2.4-.6 0-1.1-.2-1.6-.4V4.9c.6-.3 1.3-.4 2-.4Z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>',
    },
    {
      match: /(calm|balance|stress|relax|restor|resilien)/,
      svg: '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M3 13c2-1 3-3 3-5.5 0-2 1.3-3.5 3.2-3.5 2.4 0 3.8 2.2 3 4.3-.6 1.6-2.1 2.2-3.5 2.7" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><path d="M3 16c3-1.4 5.5-1.4 8-.3 2.4 1 4.3.7 6-1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>',
    },
    {
      match: /(sleep|rest)/,
      svg: '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M15.5 12.4A6 6 0 1 1 7.6 4.5a5 5 0 0 0 7.9 7.9Z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>',
    },
    {
      match: /(vital|energy|strength|rejuven)/,
      svg: '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10 3v2.4M10 14.6V17M3 10h2.4M14.6 10H17M5.5 5.5l1.7 1.7M12.8 12.8l1.7 1.7M14.5 5.5l-1.7 1.7M7.2 12.8l-1.7 1.7" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><circle cx="10" cy="10" r="2.6" stroke="currentColor" stroke-width="1.3"/></svg>',
    },
    {
      match: /(digest|gut|stomach)/,
      svg: '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M8 3c-1 2-2.5 3-2.5 5.5A4.5 4.5 0 0 0 10 13a4.5 4.5 0 0 0 4.5-4.5c0-1.6-.6-2.4-1.5-3.3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/><path d="M7 16.5c1-.8 2-.8 3 0s2 .8 3 0" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>',
    },
    {
      match: /(immun|defen)/,
      svg: '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10 2.8 16 5v4.5c0 4-2.6 6.9-6 8.2-3.4-1.3-6-4.2-6-8.2V5l6-2.2Z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><path d="M7.3 10.1l1.9 1.9 3.5-3.7" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    },
    {
      match: /(pigment|antioxid|colou?r)/,
      svg: '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10 2.5c2.6 3.4 5 6.6 5 9.4a5 5 0 1 1-10 0c0-2.8 2.4-6 5-9.4Z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>',
    },
  ];
  const ROLE_ICON_DEFAULT =
    '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M4 16c0-7 4-11.5 12-11.5C15.5 12 11 16 4 16Z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><path d="M4 16c2-3 4.5-5.5 8-7.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>';
  const pickRoleIcon = (title) => {
    const text = normalize(title);
    const found = ROLE_ICONS.find((entry) => entry.match.test(text));
    return found ? found.svg : ROLE_ICON_DEFAULT;
  };

  const initArticle = () => {
    const root = document.querySelector('[data-h9-ing-article]');
    if (!root) return;
    const source = root.querySelector('[data-h9-ing-source] .rte') || root.querySelector('[data-h9-ing-source]');
    const mount = root.querySelector('[data-h9-ing-parsed]');
    if (!source || !mount) return;
    if (mount.dataset.h9Done) return;
    mount.dataset.h9Done = 'true';

    const h1 = normalize(root.querySelector('h1') && root.querySelector('h1').textContent);
    const latin = normalize(root.querySelector('.h9-ing__latin') && root.querySelector('.h9-ing__latin').textContent);
    const nodes = Array.from(source.children);
    if (!nodes.length) return;

    const buckets = {
      intro: [],
      roles: [],
      glance: [],
      use: [],
      botany: [],
      origins: [],
      blends: [],
      origin: [],
      precautions: [],
      disclaimer: [],
      closer: [],
    };
    let current = 'intro';
    let matched = 0;

    nodes.forEach((node) => {
      const nodeText = normalize(node.textContent);
      const key = headingKey(node.textContent);
      if (current === 'intro' && !key && (nodeText === h1 || (latin && nodeText === latin))) return;
      if (key) {
        current = key;
        matched += 1;
        if (key === 'closer' || key === 'roles' || key === 'glance' || key === 'blends' || key === 'notes') return;
        if (key === 'use' || key === 'botany' || key === 'origins') return;
        if (key === 'precautions' || key === 'disclaimer') {
          buckets[key].push(node.cloneNode(true));
          return;
        }
        return;
      }
      if (buckets[current]) buckets[current].push(node.cloneNode(true));
    });

    if (matched < 3) return;

    const htmlOf = (list) => list.map((node) => node.outerHTML).join('');

    const intro = htmlOf(buckets.intro);
    const roleNodes = buckets.roles;
    let rolesHtml = '';
    if (roleNodes.length) {
      const cards = [];
      for (let i = 0; i < roleNodes.length; i += 1) {
        const title = (roleNodes[i].textContent || '').trim();
        const next = roleNodes[i + 1];
        const nextIsShort = next && (next.textContent || '').trim().length < 80 && headingKey(next.textContent) === '';
        if (
          (next && !headingKey(next.textContent) && (next.textContent || '').trim().length >= 40) ||
          nextIsShort
        ) {
          cards.push(
            `<article class="h9-ing__role"><span class="h9-ing__role-icon">${pickRoleIcon(title)}</span><h3>${roleNodes[i].innerHTML}</h3><div>${next.innerHTML}</div></article>`
          );
          i += 1;
        }
      }
      if (cards.length) {
        rolesHtml = `<section class="h9-ing__roles-block"><h2>Role in herbalism</h2><div class="h9-ing__roles">${cards.join('')}</div></section>`;
      }
    }

    const glanceRows = [];
    const glanceNodes = buckets.glance;
    for (let i = 0; i < glanceNodes.length; i += 1) {
      const label = (glanceNodes[i].textContent || '').trim();
      const valueNode = glanceNodes[i + 1];
      if (!valueNode) break;
      const value = (valueNode.textContent || '').trim();
      if (label && value && label.length < 48) {
        glanceRows.push(`<tr><th scope="row">${glanceNodes[i].innerHTML}</th><td>${valueNode.innerHTML}</td></tr>`);
        i += 1;
      }
    }

    const tab = (id, label, body, checked) => {
      if (!body) return '';
      return `<button type="button" class="h9-ing__tab${checked ? ' is-active' : ''}" data-h9-ing-tab="${id}" aria-pressed="${checked ? 'true' : 'false'}">${label}</button>`;
    };
    const panel = (id, body, checked) => {
      if (!body) return '';
      return `<div class="h9-ing__panel${checked ? ' is-active' : ''}" data-h9-ing-panel="${id}">${body}</div>`;
    };

    const useHtml = htmlOf(buckets.use);
    const botanyHtml = htmlOf(buckets.botany);
    const originsHtml = htmlOf(buckets.origins);
    const firstTab = useHtml ? 'use' : botanyHtml ? 'botany' : 'origins';

    const tabsNav = [
      tab('use', 'Traditional Use', useHtml, firstTab === 'use'),
      tab('botany', 'Botany', botanyHtml, firstTab === 'botany'),
      tab('origins', 'Origins', originsHtml, firstTab === 'origins'),
    ].join('');

    const tabsBody = [
      panel('use', useHtml, firstTab === 'use'),
      panel('botany', botanyHtml, firstTab === 'botany'),
      panel('origins', originsHtml, firstTab === 'origins'),
    ].join('');

    const closerImg = root.querySelector('[data-h9-ing-closer-image] img');
    const closerImage = closerImg ? `<div class="h9-ing__look-media">${closerImg.outerHTML}</div>` : '';

    const closerHtml =
      tabsNav && tabsBody
        ? `<section class="h9-ing__look"><h2>A closer look</h2><div class="h9-ing__tablist" role="tablist">${tabsNav}</div><div class="h9-ing__look-grid"><div class="h9-ing__look-main">${tabsBody}</div>${closerImage}</div></section>`
        : '';

    const glanceHtml = glanceRows.length
      ? `<section class="h9-ing__glance"><h2>${(root.querySelector('h1') && root.querySelector('h1').textContent) || ''} at a glance</h2><div class="h9-ing__table-wrap"><table class="h9-ing__table">${glanceRows.join('')}</table></div></section>`
      : '';

    const noteRow = (list) => {
      if (list.length < 2) return '';
      const [head, ...rest] = list;
      return `<div class="h9-ing__note-row"><h4>${head.innerHTML}</h4><div>${htmlOf(rest)}</div></div>`;
    };
    const extra = noteRow(buckets.precautions) + noteRow(buckets.disclaimer);

    const metafieldGlance = root.querySelector('.h9-ing__wrap > .h9-ing__glance');
    const glanceBlock = glanceHtml || (metafieldGlance ? metafieldGlance.outerHTML : '');
    const benefitsBlock =
      rolesHtml && glanceBlock
        ? `${rolesHtml}<hr class="h9-ing__divider">${glanceBlock}`
        : `${rolesHtml}${glanceBlock}`;

    mount.innerHTML = `${intro ? `<div class="h9-ing__lede h9-ing__lede--article">${intro}</div><hr class="h9-ing__intro-divider">` : ''}${benefitsBlock}${extra ? `<div class="h9-ing__note"><h2>Additional Information</h2>${extra}</div>` : ''}`;
    mount.hidden = false;
    source.parentElement.hidden = true;

    if (metafieldGlance) metafieldGlance.remove();

    const tabsMount = root.querySelector('[data-h9-ing-tabs]');
    if (closerHtml && tabsMount) {
      tabsMount.innerHTML = closerHtml;
      tabsMount.hidden = false;
    }

    root.querySelectorAll('[data-h9-ing-tab]').forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.getAttribute('data-h9-ing-tab');
        root.querySelectorAll('[data-h9-ing-tab]').forEach((item) => {
          const on = item === button;
          item.classList.toggle('is-active', on);
          item.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-h9-ing-panel]').forEach((item) => {
          item.classList.toggle('is-active', item.getAttribute('data-h9-ing-panel') === id);
        });
      });
    });
  };

  initIndex();
  initArticle();
})();
